import FooterPrivacy from 'src/views/auth/components/baseTemplate/FooterPrivacy';
import { isSiteCanadian } from 'src/utils/helpers';
import { IUser } from '../../../../utils/interfaces/user';
import { NotificationType } from 'src/components/ui/notification/Notification';
import { PaymentsService } from 'src/services/payments.service';
import Spinner from 'src/components/ui/spinner';
import TooltipIcon from 'src/components/ui/tooltip';
import { useLocalization } from 'src/utils/useLocalization';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import {
    PaymentDataSearhType,
    PaymentSource,
} from 'src/utils/enums/payment.enum';
import WarningNotification, {
    getWarningMessageKey,
} from 'src/views/pages/payments/ui/WarningNotification';
import './styles.scss';

const PayoffQuoteComponent = () => {
    const navigation = useNavigate();
    const dealer = useSelector((state: IUser) => {
        return state.dealerDataInfo?.dealer;
    });

    const dealerId = useSelector((state: IUser) => {
        return state.currentDealers?.default;
    });
    const [brand, dealerName, dccNumber] = useSelector((state: IUser) => {
        return [
            state.dealerDataInfo?.dealer.brand ?? 'VW',
            state.dealerDataInfo?.dealer.dealerName ?? '',
            state.dealerDataInfo?.dealer.ccNumbers[0].toString() ?? '',
        ];
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [warninMessageKey, setWarninMessageKey] = useState('');

    const { payments, payoffQuotes } = useLocalization();
    const [payment, setPayment] = useState({
        account: '',
        errAccount: false,
        vin: '',
        errVin: false,
    });

    const isAudi = ['AUDI', 'Audi', 'audi'].includes(dealer?.brand ?? '');
    const isCanadian = isSiteCanadian();

    const PAGE_LINKS = {
        CA: {
            audi: {
                text: 'audipreowneddirect.ca',
                url: 'https://audipreowneddirect.ca',
            },
            vw: {
                text: 'vwpreowneddirect.ca',
                url: 'https://vwpreowneddirect.ca',
            },
        },
        US: {
            audi: { text: 'AudiDirect.us', url: 'http://www.audidirect.us/' },
            vw: {
                text: 'VolkswagenDirect.us',
                url: 'http://www.volkswagendirect.us/',
            },
        },
    };

    const { text: pageLinkDisplayText, url: pageLinkUrl } =
        PAGE_LINKS[isCanadian ? 'CA' : 'US'][isAudi ? 'audi' : 'vw'];
    const handleSubmit = async () => {
        let errorAcc = null;
        let errorVIN = null;
        let searchValue = '';
        let searchType = null;
        clearErrors();
        if (payment.account.length) {
            if (
                payment.account.length < Number('9') ||
                payment.account.length > Number('14') ||
                new RegExp('/^\\d+$/').test(payment.account)
            ) {
                errorAcc = true;
                setPayment((oldValue) => {
                    return { ...oldValue, errAccount: true };
                });
            } else {
                errorAcc = false;
                setPayment((oldValue) => {
                    return { ...oldValue, errAccount: false };
                });
                searchValue = payment.account;
                searchType = PaymentDataSearhType.Account;
            }
        } else {
            errorAcc = false;
            setPayment((oldValue) => {
                return { ...oldValue, errAccount: false };
            });
        }

        if (payment.vin.length) {
            if (
                payment.vin.length != Number('17') ||
                new RegExp('[A-HJ-NPR-Z0-9]{17}').test(payment.vin) === false
            ) {
                errorVIN = true;
                setPayment((oldValue) => {
                    return { ...oldValue, errVin: true };
                });
            } else {
                errorVIN = false;
                setPayment((oldValue) => {
                    return { ...oldValue, errVin: false };
                });
                searchValue = payment.vin;
                searchType = PaymentDataSearhType.Vin;
            }
        } else {
            errorVIN = false;
            setPayment((oldValue) => {
                return { ...oldValue, errVin: false };
            });
        }

        if (
            errorAcc === false &&
            errorVIN === false &&
            dealerId &&
            searchType
        ) {
            setIsLoading(true);
            const service = new PaymentsService();
            try {
                const res = await service.paymentData(
                    dealerId,
                    searchType,
                    searchValue,
                    PaymentSource.Quote,
                    brand,
                    dealerName,
                    dccNumber,
                );
                setIsLoading(false);
                const data = JSON.stringify({ ...res.data });
                const encodedData = btoa(data);

                navigation(
                    `/dashboard/payoff-quotes/details?data=${encodedData}`,
                );
            } catch (error) {
                setIsLoading(false);
                setWarninMessageKey(getWarningMessageKey(error));
                setIsError(true);
            }
        }
    };

    function clearErrors() {
        setIsError(false);
        setWarninMessageKey('');
    }

    return (
        <div className='dashboard-content-wrapper'>
            <div className={'dashboard-content-container'}>
                <div className='quote-wrapper'>
                    <section className='o-content-section  '>
                        <div className={''}>
                            {isError && (
                                <div className='u-mb-small'>
                                    <WarningNotification
                                        type={NotificationType.ERROR}
                                        visibility={isError}
                                        setVisibility={setIsError}
                                        warningMessageKey={warninMessageKey}
                                    />
                                </div>
                            )}
                            <h5 className=''>
                                <span className='c-section-heading__title-text'>
                                    {payoffQuotes.TITLE}
                                </span>
                            </h5>
                            <section className='description'>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: payoffQuotes.ADVISORY,
                                    }}
                                />
                            </section>
                            <section className='highlight-description'>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: payoffQuotes.LINK,
                                    }}
                                />
                                <a
                                    href={pageLinkUrl}
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    {pageLinkDisplayText}
                                </a>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: payoffQuotes.LINK2,
                                    }}
                                />
                            </section>

                            <section className='c-form-section'>
                                <div className='c-form-section__content'>
                                    <div className='o-fieldset__row u-mt-large u-mb-large header-input'>
                                        <div className='o-layout'>
                                            <div className='o-layout__item  u-1/2  u-1/1@xs'>
                                                <div className='c-form-field'>
                                                    <div className='c-form-field__box'>
                                                        <div>
                                                            <label
                                                                htmlFor='m1l7e063'
                                                                className='c-form-field__label u-mr-xsmall'
                                                            >
                                                                {
                                                                    payments.PAYMENT_MAKE_ACCOUNTLABEL
                                                                }
                                                            </label>
                                                            <TooltipIcon
                                                                text={
                                                                    payments.PAYMENT_MAKE_ACCOUNTTIP
                                                                }
                                                            ></TooltipIcon>
                                                        </div>
                                                        <div className='c-input'>
                                                            <input
                                                                className={`c-input__input ${
                                                                    payment.errAccount
                                                                        ? 'is-error'
                                                                        : ''
                                                                }`}
                                                                onChange={(
                                                                    event,
                                                                ) => {
                                                                    const re =
                                                                        /^[0-9\b]+$/;

                                                                    if (
                                                                        event
                                                                            .target
                                                                            .value ===
                                                                            '' ||
                                                                        re.test(
                                                                            event
                                                                                .target
                                                                                .value,
                                                                        )
                                                                    ) {
                                                                        setPayment(
                                                                            (
                                                                                oldValue,
                                                                            ) => {
                                                                                return {
                                                                                    ...oldValue,
                                                                                    account:
                                                                                        event
                                                                                            .target
                                                                                            .value,
                                                                                };
                                                                            },
                                                                        );
                                                                    }
                                                                }}
                                                                type='text'
                                                                value={
                                                                    payment.account
                                                                }
                                                                minLength={9}
                                                                maxLength={14}
                                                            />
                                                        </div>
                                                        <div>
                                                            {payment.errAccount ? (
                                                                <span
                                                                    className={
                                                                        'c-error-message'
                                                                    }
                                                                >
                                                                    {
                                                                        payments.PAYMENT_MAKE_ACCOUNTERROR
                                                                    }
                                                                </span>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='o-fieldset__row u-mt-large'>
                                        <div className='o-layout'>
                                            <div className='o-layout__item  u-1/2  u-1/1@xs'>
                                                <div className='c-form-field'>
                                                    <div className='c-form-field__box'>
                                                        <div>
                                                            <label
                                                                htmlFor='m1l7e063'
                                                                className='c-form-field__label u-mr-xsmall'
                                                            >
                                                                {
                                                                    payments.PAYMENT_MAKE_VINLABEL
                                                                }
                                                            </label>
                                                            <TooltipIcon
                                                                text={
                                                                    payments.PAYMENT_MAKE_VINTIP
                                                                }
                                                            ></TooltipIcon>
                                                        </div>
                                                        <div className='c-input'>
                                                            <input
                                                                className={`c-input__input ${
                                                                    payment.errVin
                                                                        ? 'is-error'
                                                                        : ''
                                                                }`}
                                                                onChange={(
                                                                    event,
                                                                ) => {
                                                                    const value =
                                                                        event.target.value.toLocaleUpperCase();
                                                                    const vinRegex =
                                                                        /^[A-HJ-NPR-Z0-9]*$/;

                                                                    if (
                                                                        vinRegex.test(
                                                                            value,
                                                                        ) &&
                                                                        value.length <=
                                                                            Number(
                                                                                '17',
                                                                            )
                                                                    ) {
                                                                        setPayment(
                                                                            (
                                                                                oldValue,
                                                                            ) => {
                                                                                return {
                                                                                    ...oldValue,
                                                                                    vin: value,
                                                                                };
                                                                            },
                                                                        );
                                                                    }
                                                                }}
                                                                type='text'
                                                                value={
                                                                    payment.vin
                                                                }
                                                                minLength={17}
                                                                maxLength={17}
                                                            />
                                                        </div>
                                                        <div className='error-label'>
                                                            {payment.errVin ? (
                                                                <span
                                                                    className={
                                                                        'c-error-message'
                                                                    }
                                                                >
                                                                    {
                                                                        payments.PAYMENT_MAKE_VINERROR
                                                                    }
                                                                </span>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='o-layout__item  u-1/1  u-1/1@xs'>
                                                <div className='o-fieldset__row button-group'>
                                                    <button
                                                        className={`c-btn ${
                                                            payment.account
                                                                .length ===
                                                                Number('0') &&
                                                            payment.vin
                                                                .length ===
                                                                Number('0')
                                                                ? 'btn-secondary'
                                                                : ''
                                                        }`}
                                                        type='button'
                                                        onClick={handleSubmit}
                                                        disabled={
                                                            payment.account
                                                                .length ===
                                                                Number('0') &&
                                                            payment.vin
                                                                .length ===
                                                                Number('0')
                                                        }
                                                    >
                                                        <span className='c-btn__text'>
                                                            {isLoading ? (
                                                                <Spinner />
                                                            ) : (
                                                                payoffQuotes.SEARCH
                                                            )}
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </section>
                    <section className='privacy-footer-container '>
                        <FooterPrivacy />
                    </section>
                </div>
            </div>
        </div>
    );
};

export const LinkText = (props: any) => {
    return (
        <a
            href={props.to || '#'}
            target='_blank'
            title={props.title || ''}
            rel='noreferrer'
        >
            {props.children}
        </a>
    );
};

export default PayoffQuoteComponent;
